import { annualReport } from "./annual_report";
import { collections } from "./collections";
import { emojis } from "./emojis";
import { profileEdit } from "./profile_edit";
import { welcomeDigest } from "./welcome_digest";

export const sliceReducers = {
  annualReport,
  collections,
  emojis,
  profileEdit,
  welcomeDigest,
};
